import styled from "@emotion/styled";

export const ScrollAreaStyled = styled("div")`
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0; // allow it to be less than the height of its children
    max-height: 100%;
    position: relative; // for keyline positioning
`;
